module.exports = __webpack_public_path__ + "img/params.5a928c19.svg";